import React from 'react'
import AuthLayout from '@SiteContainers/AuthLayout'

import './UsersPasswordNew.scss'

const UsersPasswordNew: React.FC = () => {
  return (
    <div className="UsersPasswordNew">
      <AuthLayout initialScreen="forgot"/>
    </div>
  )
}

export default UsersPasswordNew
